import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import {
  // Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Axios from "../../lib/Axios";

const CompanyPage = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const [searchTerm, setSearchTerm] = useState("");
  const columns = useMemo(
    () => [
        {
            name: <span className="font-weight-bold fs-13">Interest Name</span>,
            selector: (row) => row.interestName,
            sortable: true,
          },
          {
            name: <span className="font-weight-bold fs-13">Frequency</span>,
            selector: (row) => Number(row.frequency),
            sortable: true,
          },
    ],
    []
  );

  async function fetchList() {
    try {
      const result = await Axios.post("/cms/cms-get/interest-count");
      setData(result?.data?.result?.results);
      setFilteredData(result?.data?.result?.results)
    } catch (error) {}
  }

  // Filter function
  const handleFilter = (event) => {
    const value = event?.target?.value?.toLowerCase();
    setSearchTerm(value);

    const filtered = data.filter((item) =>
      item.interestName.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };


  useEffect(() => {
    fetchList();
  }, []);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Interest-Frequency" />
          <Col lg={12}>
            <Card>
              <CardHeader>
                {/* <h4 className="card-title mb-0">Add, Edit & Remove</h4> */}
              </CardHeader>
              <CardBody>
                <div id="customerList">
                  <Row className="g-4 mb-3">
                    <Col className="col-sm-auto">
                      <div className="d-flex gap-1">
                      </div>
                    </Col>
                    <Col className="col-sm">
                      <div className="d-flex justify-content-sm-end">
                        <div className="search-box ms-2">
                          <input
                            type="text"
                            className="form-control search"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleFilter}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <DataTable columns={columns} data={filteredData}  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  );
};


export default CompanyPage;
